import type { MultipleQueriesQuery } from '@algolia/client-search'

type AlgoliaSearchFn<T extends { results: { hits: unknown[] }[] }> = (
  queries: MultipleQueriesQuery[],
) => Promise<T>

export type InitializableAlgoliaClient<
  T extends { results: { hits: unknown[] }[] },
> = (id: string, apiKey: string) => { search: AlgoliaSearchFn<T> }

// TODO: Use an ordered-builder pattern to make this more readable
// (id, apiKey) => (queriesTransformer) => (queries) => algolia results
export const initializeAlgoliaClientWith =
  <T extends { results: { hits: unknown[] }[] }>(
    initializableAlgoliaClient: InitializableAlgoliaClient<T>,
  ) =>
  (id: string, apiKey: string) =>
  (
    transformQueriesFn: (
      queries: MultipleQueriesQuery[],
    ) => MultipleQueriesQuery[],
  ) =>
  (queries: MultipleQueriesQuery[]) => {
    const { search } = initializableAlgoliaClient(id, apiKey)

    const transformedQueries = transformQueriesFn(queries)

    return search(transformedQueries)
  }
